import type { RemedialActionPriority } from "@/services/api/case-checking";

const PRIORITY_RANK: Record<RemedialActionPriority, number> = {
  high: 0,
  medium: 1,
  low: 2,
};

export const REMEDIAL_PRIORITY_META: Record<
  RemedialActionPriority,
  { label: string; helper: string; dotClass: string; badgeClass: string }
> = {
  high: {
    label: "Must have",
    helper: "Blocking — address before sign-off.",
    dotClass: "bg-rose-500",
    badgeClass:
      "text-rose-800 ring-rose-300 bg-rose-100 dark:text-rose-200 dark:ring-rose-500/30 dark:bg-rose-500/10",
  },
  medium: {
    label: "Nice to have",
    helper: "Important but not blocking.",
    dotClass: "bg-amber-500",
    badgeClass:
      "text-amber-800 ring-amber-300 bg-amber-100 dark:text-amber-200 dark:ring-amber-500/25 dark:bg-amber-500/10",
  },
  low: {
    label: "Optional",
    helper: "When capacity allows.",
    dotClass: "bg-slate-400",
    badgeClass:
      "text-slate-700 ring-slate-300 bg-slate-100 dark:text-slate-300 dark:ring-white/15 dark:bg-white/[0.06]",
  },
};

export const REMEDIAL_PRIORITY_SELECT_OPTIONS: { id: RemedialActionPriority; label: string }[] = (
  ["high", "medium", "low"] as RemedialActionPriority[]
).map((id) => ({
  id,
  label: REMEDIAL_PRIORITY_META[id].label,
}));

export function compareRemedialActionPriority(
  a: RemedialActionPriority,
  b: RemedialActionPriority,
): number {
  return PRIORITY_RANK[a] - PRIORITY_RANK[b];
}

export function sortRemedialActionsByPriority<T extends { priority: RemedialActionPriority; title?: string }>(
  actions: T[],
): T[] {
  return [...actions].sort((left, right) => {
    const byPriority = compareRemedialActionPriority(left.priority, right.priority);
    if (byPriority !== 0) return byPriority;
    return (left.title ?? "").localeCompare(right.title ?? "", undefined, { sensitivity: "base" });
  });
}
